<template>
<div>
  <!-- <loading 
  :active.sync="isLoading" 
        :is-full-page="true"
        color="green"
        ></loading> -->
<billingoverview :key="billingSummary"
:billingHistory="billingSummary"
:overallsummary="overallSummary"
:allGlobalTotals="allGlobalTransactions">
    </billingoverview>
</div>

    
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import BillingOverview from '@/components/BillingOverview.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    components:{
        billingoverview: BillingOverview,
        loading: Loading
    },
    data(){
        return{
          isLoading: true,
            billingDetails: false,
            billingSummary:[],
            allGlobalTransactions:[],
            overallSummary:[],
            allDateTransactions:[]
        }
    },
    watch:{
      '$route.query.billingDate':{
        immediate: true,
        handler(value){
          if(typeof value !=='undefined'){
        Api()
        .get('/transactions/globalByDate',{
          params:{
            billingDate: this.$route.query.billingDate
          }
        })
        .then(response=>{
            this.allDateTransactions=response.data
            this.calculateBillingHistory(this.allDateTransactions)
        })
          } else {
            Api()
        .get('/transactions/allGlobal')
        .then(response=>{
            this.allGlobalTransactions=response.data
            this.calculateGlobalTotals(this.allGlobalTransactions)
        })
          }
          
        }
      }
    },
    async created(){
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/billingOverview'})
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.getGlobalTransactions()
            Api()
            .get('/billingHistorySummary')
            .then(response=>{
                this.billingSummary=response.data
            });
    } else {
      this.$router.push({ name: "SplashPage" });
    }},
    methods:{
      async calculateBillingHistory(transactions){
        var helper = {};
      this.billingSummary=[];
      let summary = transactions.filter(function(el){
        return el.transactionType==='Sales'
      })
      this.billingSummary = await transactions.reduce(function(r, o) {
        let key = null
          key = o.organisationId+'-'+o.customerOrganisationId+'-'+o.supplierOrganisationId+'-'+o.transactionType+ +'-'+o.date;
        
        
        if(!helper[key]) {
          helper[key] = Object.assign({}, o);
          r.push(helper[key]);
        } else {
          helper[key].amount += o.amount;
        }

        return r;
      }, []);
      let overallSummary = await transactions.reduce(function(r, o) {
        var key = o.date+'-'+o.transactionType+'-'+o.customerOrganisationId+'-'+o.supplierOrganisationId;
        
        if(!helper[key]) {
          helper[key] = Object.assign({}, o);
          r.push(helper[key]);
        } else {
          helper[key].amount += o.amount;
        }

        return r;
      }, []);
      },
    async calculateGlobalTotals(transactions) {
      var helper = {};
      this.overallSummary=[]
      this.billingSummary=[];
      this.billingSummary = await transactions.reduce(function(r, o) {
        let key = o.organisationId+'-'+o.customerOrganisationId+'-'+o.supplierOrganisationId+'-'+o.transactionType+ +'-'+o.date;
        
        
        
        if(!helper[key]) {
          helper[key] = Object.assign({}, o); // create a copy of o
          r.push(helper[key]);
        } else {
          helper[key].amount += o.amount;
        }

        return r;
      }, []);
      let overallSummary = await transactions.reduce(function(r, o) {
        let key = o.organisationId+'-'+o.transactionType+ +'-'+o.date;
        
        if(!helper[key]) {
          helper[key] = Object.assign({}, o); // create a copy of o
          r.push(helper[key]);
        } else {
          helper[key].amount += o.amount;
        }

        return r;
      }, []);
      for(let i=0;i< overallSummary.length;i++){
        // let summary={date: null, debit:0, credit:0}
        let index = this.overallSummary.map(e => e.date).indexOf(overallSummary[i].date)
        if(index===-1){
          this.overallSummary.push({date: overallSummary[i].date, debit:0, credit:0})
          index = this.overallSummary.map(e => e.date).indexOf(overallSummary[i].date)
          if(overallSummary[i].transactionType==='Sales'||overallSummary[i].transactionType==='Loan'){
            this.overallSummary[index].credit += overallSummary[i].amount
          } else {
            this.overallSummary[index].debit += overallSummary[i].amount
          }
        } else {
          if(overallSummary[i].transactionType==='Sales'||overallSummary[i].transactionType==='Loan'){
            this.overallSummary[index].credit += overallSummary[i].amount
          } else {
            this.overallSummary[index].debit += overallSummary[i].amount
          }
        }
      }
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    getGlobalTransactions(){
        Api()
        .get('/transactions/allGlobal')
        .then(response=>{
            this.allGlobalTransactions=response.data
            this.calculateGlobalTotals(this.allGlobalTransactions)
        })
    }

        }
}
</script>
